import React from 'react';
import { createContext, useState, useContext, useEffect, useCallback, useRef } from 'react';

const NfseContext = createContext();

const STORAGE_KEY = 'nfseEmitDraft';

// 2. Criar o Provider (O "provedor" de dados)
export function NfseProvider({ children }) {

  const [step, setStep] = useState(0)
  const [type, setType] = useState(1)

  const [rps, setRps] = useState({})
  const [taker, setTaker] = useState({})
  const [service, setService] = useState({})
  const [items, setItems] = useState([])

  const hydratedRef = useRef(false);
  const skipPersistRef = useRef(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed && typeof parsed === 'object') {
          if (parsed.rps) setRps(parsed.rps);
          if (parsed.taker) setTaker(parsed.taker);
          if (parsed.service) setService(parsed.service);
          if (Array.isArray(parsed.items)) {
            setItems(parsed.items);
          }
        }
      }
    } catch (error) {
      console.error('[NFSe] Falha ao carregar rascunho da emissão', error);
    } finally {
      hydratedRef.current = true;
    }
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined' || !hydratedRef.current) {
      return;
    }

    if (skipPersistRef.current) {
      skipPersistRef.current = false;
      window.localStorage.removeItem(STORAGE_KEY);
      return;
    }

    try {
      const payload = JSON.stringify({ rps, taker, service, items });
      window.localStorage.setItem(STORAGE_KEY, payload);
    } catch (error) {
      console.error('[NFSe] Falha ao salvar rascunho da emissão', error);
    }
  }, [rps, taker, service, items]);

  const clearDraft = useCallback(() => {
    skipPersistRef.current = true;
    setRps({});
    setTaker({});
    setService({});
    setItems([]);

    if (typeof window !== 'undefined') {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  }, []);

  return (
    <NfseContext.Provider value={{ rps, setRps, taker, setTaker, service, setService, items, setItems, clearDraft }}>
      {children}
    </NfseContext.Provider>
  );
}

// 3. Criar um Hook personalizado para facilitar o uso (opcional, mas recomendado)
export function useNfse() {
  return useContext(NfseContext);
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/emit/context/index.jsx